// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1dca982a","453":"e57c4441"}[chunkId] + ".chunk.js";
};